import React, { useEffect, useRef, useState } from "react";
import { ArrowRight, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdvancingProsperityHero() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const sectionRef = useRef<HTMLElement>(null);
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const {
        innerWidth,
        innerHeight
      } = window;
      const x = clientX / innerWidth * 2 - 1;
      const y = clientY / innerHeight * 2 - 1;
      setMousePos({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section id="advancing-prosperity-hero" ref={sectionRef} className="relative w-full overflow-hidden bg-background py-32 md:py-48 lg:py-56">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-10" style={{
      transform: `translate(${mousePos.x * -20}px, ${mousePos.y * -20}px)`,
      transition: "transform 0.2s ease-out"
    }}>
        <svg className="h-full w-full text-primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600" preserveAspectRatio="xMidYMid slice">
          <path fill="none" stroke="currentColor" strokeWidth="1" d="M0,300 Q200,100 400,300 T800,300 M0,350 Q200,150 400,350 T800,350 M0,400 Q200,200 400,400 T800,400 M0,250 Q200,50 400,250 T800,250 M0,200 Q200,0 400,200 T800,200 M0,450 Q200,250 400,450 T800,450 M0,500 Q200,300 400,500 T800,500 M0,150 Q200,-50 400,150 T800,150" />
          <path fill="none" stroke="currentColor" strokeWidth="0.5" d="M-100,300 Q100,500 300,300 T700,300 M-100,350 Q100,550 300,350 T700,350 M-100,250 Q100,450 300,250 T700,250" transform="rotate(15, 400, 300)" />
        </svg>
      </div>

      {}
      <div className="relative z-10 mx-auto max-w-6xl px-6 text-center">
        <div ref={textRef} className={`transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <h1 className="font-serif text-5xl font-extrabold leading-tight tracking-tight text-primary md:text-7xl lg:text-8xl">
            Investing in{" "}
            <span className="relative inline-block">
              Opportunity
              <svg className="absolute -bottom-2 left-0 h-3 w-full text-secondary md:-bottom-4 md:h-4" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" />
              </svg>
            </span>
            .<br className="hidden md:block" /> Advancing{" "}
            <span className="relative inline-block">
              Prosperity
              <svg className="absolute -bottom-2 left-0 h-3 w-full text-secondary md:-bottom-4 md:h-4" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" />
              </svg>
            </span>
            .
          </h1>

          {}
          <p className="mx-auto mt-8 max-w-2xl font-sans text-lg font-medium text-foreground/80 md:mt-10 md:text-2xl">
            Empowering Colorado’s Hispanic community through entrepreneurship,
            leadership, education, and workforce development.
          </p>

          {}
          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row md:mt-16 md:gap-6">
            <Button asChild size="lg" className="h-14 min-w-[180px] rounded-lg bg-secondary px-8 text-lg font-bold text-secondary-foreground shadow-lg transition-transform hover:scale-105 hover:bg-secondary/90">
              <Link to="/GetInvolvedPage">
                <Heart className="mr-2 size-5 fill-current" />
                Donate
              </Link>
            </Button>

            <Button asChild variant="default" size="lg" className="h-14 min-w-[180px] rounded-lg bg-primary px-8 text-lg font-bold text-primary-foreground shadow-lg transition-transform hover:scale-105 hover:bg-primary/90">
              <Link to="/MissionVisionPage">
                Learn More
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}